import { render, staticRenderFns } from "./civilOrder6.vue?vue&type=template&id=19341d36&scoped=true&"
import script from "./civilOrder6.vue?vue&type=script&lang=js&"
export * from "./civilOrder6.vue?vue&type=script&lang=js&"
import style0 from "./civilOrder6.vue?vue&type=style&index=0&id=19341d36&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19341d36",
  null
  
)

export default component.exports